module.exports = __webpack_public_path__ + "static/img/sybanner-1.524cade.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sybanner-1.png
// module id = YtQ6
// module chunks = 0